module.exports = __webpack_public_path__ + "img/biscuit-chinois.a43cd62e.png";